import { TabItem } from './types'

interface TabWrapperProps {
  tabs: TabItem[]
  currentTab: string
  onChange: (key: string) => void
  className?: string
}

export default function TabWrapper({
  tabs,
  currentTab,
  onChange,
  className = ''
}: TabWrapperProps) {
  return (
    <div
      className={`flex flex-row flex-nowrap overflow-x-auto scroll-px-4 snap-x snap-mandatory self-stretch bg-white rounded-xl p-2 gap-3 ${className}`}
      role="tablist"
      aria-orientation="horizontal"
    >
      {tabs.map((t) => {
        const isActive = currentTab === t.key
        const Icon = t.icon
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            className={`flex flex-row flex-shrink-0 snap-start ${isActive ? 'bg-valley-main' : ''} gap-[8px] px-3 py-2 items-center rounded-lg cursor-pointer whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-valley-main`}
            onClick={() => onChange(t.key)}
          >
            <Icon additionalStyle={isActive ? 'text-white' : 'text-valley-main'} />
            <span className={`font-medium leading-[19.2px] ${isActive ? 'text-white' : 'text-valley-black'}`}>
              {t.label}
            </span>
          </button>
        )
      })}
    </div>
  )
}